import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';
import { Snapshot } from 'types';

interface Props {
  open: boolean;
  existingImportedSnapshot: Snapshot | null | undefined;
  onReplace: () => void;
  onNew: () => void;
  handleClose: () => void;
}

const SnapshotImportConfirmationDialog = ({
  existingImportedSnapshot,
  open,
  onReplace,
  onNew,
  handleClose,
}: Props) => {
  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby='alert-dialog-title'
      aria-describedby='alert-dialog-description'
    >
      <DialogTitle id='alert-dialog-title'>
        {'Replace this snapshot?'}
      </DialogTitle>
      <DialogContent>
        <DialogContentText id='alert-dialog-description'>
          {`Snapshot ${existingImportedSnapshot?.name} already exists. Do you want to replace it with the imported one?`}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onNew} variant='contained' color='primary'>
          Create As New
        </Button>
        <Button
          onClick={onReplace}
          autoFocus
          variant='contained'
          color='primary'
        >
          Replace Existing
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SnapshotImportConfirmationDialog;
